import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { IUserAdmin, IUserPublic } from '~/types/user'

import UserCard from '~/components/UserCard'
import { capitalize } from '~/utils/string'

export const IdentityCellRenderer = ({ value }: ICellRendererParams<IUserPublic | IUserAdmin>): ReactElement => {
  const user = value

  if (!user) return <div />

  const { name, picture, profile } = user

  return <UserCard name={capitalize(name)} picture={picture} size="small" subInfo={profile?.job_title} />
}
